import { cn } from "@/lib/utils";

const STYLES = {
  draft: "bg-slate-100 dark:bg-slate-800/60 text-slate-700 dark:text-slate-300 border-slate-300 dark:border-slate-700",
  submitted: "bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-300 border-amber-200 dark:border-amber-800",
  approved: "bg-emerald-50 dark:bg-emerald-950/40 text-emerald-700 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800",
  rejected: "bg-rose-50 dark:bg-rose-950/40 text-rose-700 dark:text-rose-300 border-rose-200 dark:border-rose-800",
  final: "bg-blue-50 dark:bg-blue-950/40 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-800",
  missing: "bg-transparent text-muted-foreground border-dashed border-slate-300 dark:border-slate-700",
};
const DOTS = {
  draft: "bg-slate-400",
  submitted: "bg-amber-500",
  approved: "bg-emerald-500",
  rejected: "bg-rose-500",
  final: "bg-blue-600",
  missing: "bg-slate-300",
};
const LABELS = { draft: "Draft", submitted: "Submitted", approved: "Approved", rejected: "Rejected", final: "Finalised", missing: "Not started" };

export function StatusBadge({ status, testId = "timesheet-status-badge" }) {
  const s = status || "draft";
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold",
        STYLES[s]
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", DOTS[s], s === "submitted" && "pulse-dot")} />
      {LABELS[s]}
    </span>
  );
}
